import type { DefaultNamespace } from 'i18next'
import type { FC } from 'react'
import { Container } from '@/components/ui/container'
import { IconContainer } from '@/components/ui/icon-container'
import { AlertCircleIcon, CheckIcon } from '@/components/ui/icons'

const bannerTypeToColors = {
	danger: {
		background: 'bg-danger-100',
		textColor: 'text-danger-700'
	},
	warning: {
		background: 'bg-warning-100',
		textColor: 'text-warning-700'
	},
	success: {
		background: 'bg-success-100',
		textColor: 'text-success-700'
	},
	blue: {
		background: 'bg-blue-50',
		textColor: 'text-neutral-700'
	}
} as const satisfies Record<
	'danger' | 'warning' | 'success' | 'blue',
	{ background: string; textColor: string }
>

interface SubHeaderBannerProps {
	title: string | DefaultNamespace
	subtitle?: string | DefaultNamespace
	type?: 'success' | 'danger' | 'warning' | 'blue'
	endSlot?: React.ReactNode
}

export const SubHeaderBanner: FC<SubHeaderBannerProps> = ({
	subtitle,
	title,
	type = 'danger',
	endSlot
}) => {
	const colors = bannerTypeToColors[type]

	return (
		<div className={`${colors.background} h-auto`}>
			<Container fullWidth>
				<div className='flex min-h-16 shrink-[inherit] items-center gap-3 py-3'>
					<div className='flex items-center gap-3 [&_svg]:fill-neutral-white'>
						<IconContainer type={type}>
							{type === 'success' ? (
								<CheckIcon />
							) : (
								<AlertCircleIcon />
							)}
						</IconContainer>
						<div className='flex flex-col text-sm'>
							<h3 className='font-medium text-neutral-900'>
								{title}
							</h3>
							<p className={colors.textColor}>{subtitle}</p>
						</div>
					</div>

					{endSlot && endSlot}
				</div>
			</Container>
		</div>
	)
}

SubHeaderBanner.displayName = 'SubHeaderBanner'
